import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
  const testimonialCarousels = document.querySelectorAll(
    ".testimonials-carousel"
  );

  if (testimonialCarousels) {
    testimonialCarousels.forEach(function (carousel) {
      const testimonials = new Splide(carousel, {
        type: "loop",
        perPage: 1,
        perMove: 1,
        gap: "16px",
        arrows: false,
        pagination: true,
        mediaQuery: "min",
        breakpoints: {
          768: {
            perPage: 3,
            pagination: false,
            gap: "32px",
          },
        },
      });

      testimonials.mount();

      // Bind custom arrows
      const block = carousel.closest(".testimonials-block");
      const prevBtn = block.querySelector(".custom-arrow--prev");
      const nextBtn = block.querySelector(".custom-arrow--next");

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          testimonials.go("<");
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          testimonials.go(">");
        });
      }
    });
  }
});
